import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { ResourceAmount } from "../../inventory/resource/ResourceAmount";
import { ResourceIcon } from "../icon/ResourceIcon";
import { ResourceRequirement } from "../resource-requirement/ResourceRequirement";
import { IdInventoryResourceRequirementPosition } from "./IdInventoryResourceRequirementPosition";
var _InventoryResourceRequirement = function (_a) {
    var required = _a.required, inventoryInfo = _a.inventoryInfo, _b = _a.iconStyleId, iconStyleId = _b === void 0 ? IdStyles.IconLarge : _b, _c = _a.position, position = _c === void 0 ? IdInventoryResourceRequirementPosition.Vertical : _c, resourceId = _a.resourceId, children = _a.children;
    var isResourceGold = resourceId === IdResource.Gold;
    var inventoryAmount = inventoryInfo.amount || Long.ZERO;
    var resourceInfo = selectResourceInfo(resourceId);
    var positionClass = position === IdInventoryResourceRequirementPosition.Vertical ? "flex--stacked" : "";
    var requirementElement = isResourceGold ? (React.createElement(ResourceAmount, { required: required, available: inventoryAmount })) : (React.createElement(ResourceRequirement, { required: required, available: inventoryAmount }));
    return (React.createElement("div", { className: "inventory-resource-requirement " + positionClass },
        React.createElement("div", { className: "inventory-resource-requirement__icon" },
            React.createElement(ResourceIcon, { resource: resourceInfo, styleId: iconStyleId })),
        children,
        requirementElement));
};
var mapState = function (state, _a) {
    var resourceId = _a.resourceId;
    return ({
        inventoryInfo: selectInventoryResourceInfo(state, resourceId),
    });
};
export var InventoryResourceRequirement = connect(mapState)(_InventoryResourceRequirement);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/inventory-resource-requirement/InventoryResourceRequirement.tsx
// module id = 260
// module chunks = 3